<template>
  <m-form :formModel="formModel" ref="form" />
</template>

<script>
import MForm from './m-form'
import {
  getCustomerOverview,
  getSelectList,
} from 'views/client/client-center/detail/mechanism/api'

export default {
  data() {
    return {
      formModel: [
        {
          type: 'select',
          label: '匹配类型',
          defaultValue: 1,
          key: 'matchUniverse',
          selectList: [
            {
              id: 1,
              name: 'All Businesses',
            },
            {
              id: 2,
              name: 'In Date Financials Only',
            },
            {
              id: 3,
              name: 'Major Buinesses Only',
            },
          ],
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'change' },
          ],
        },
        {
          type: 'input',
          label: 'Customer name',
          key: 'companyName',
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
        {
          type: 'select',
          label: '国家',
          key: 'country',
          selectList: [],
          rule: [
            { required: true, message: 'Can not be empty!', trigger: 'blur' },
          ],
        },
      ],
    }
  },
  created() {
    this._getCountryList()
    this._getCustomerOverview()
  },
  mounted() {},
  methods: {
    async _getCountryList() {
      try {
        const { data } = await getSelectList('Country')
        this.formModel[2].selectList = data
        this.countryList = data
      } catch (err) {
        console.error(err)
      }
    },
    async _getCustomerOverview() {
      try {
        const { data } = await getCustomerOverview(this.$route.params.id)
        this.formModel.forEach((item, index) => {
          if (item.key === 'companyName') {
            this.formModel.splice(index, 1, {
              ...item,
              defaultValue: data.base.englishName,
            })
          }
        })
      } catch (e) {
        console.log(e)
      }
    },
    async validate() {
      const valid = await this.$refs.form.validateForm()
      if (valid) {
        const result = await this.$refs.form.getFormData()
        result.country = this.countryList.filter(
          item => item.id === result.country,
        )[0].mark
        return result
      }
    },
  },
  components: {
    MForm,
  },
}
</script>
